import type { LeagueRead } from '@/api/schemas';

export const normalizedRankCompetitionIds = (ids: readonly number[] | null | undefined): number[] =>
  [...new Set((ids ?? []).filter(id => Number.isInteger(id) && id > 0))].sort((a, b) => a - b);

export const leagueRankCompetitionIds = (league: LeagueRead | null | undefined): number[] =>
  normalizedRankCompetitionIds(league?.competition_ids?.length ? league.competition_ids : league ? [league.competition_id] : []);

export const contestRankCompetitionIds = (
  contest: { competitions?: Array<{ id: number }> | null } | null | undefined,
): number[] => normalizedRankCompetitionIds(contest?.competitions?.map(comp => comp.id));

export const formatPositionRank = (position: string | null | undefined, rank: number | null | undefined): string =>
  position && rank != null ? `${position}${rank}` : 'N/A';

/** Unranked players stay below ranked players in either sort direction. */
export const compareNullableRank = (
  a: number | null | undefined,
  b: number | null | undefined,
  direction: 1 | -1,
): number => {
  if (a == null) return b == null ? 0 : 1;
  if (b == null) return -1;
  return direction * (a - b);
};
